import { ControlFacet } from '../controls/ControlFacet';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { IFaceted } from '../Facet';
import { IItemColumn } from './IItemColumn';

export interface IItemColumnRendererProps {
  key: string;
  isInvokable: boolean;
  isDisabled: boolean;
}

export interface IItemColumnRenderControlProps {
  /**
   * The key for the item being rendered.
   */
  itemKey: string;
  /**
   * The index of the item within its parent list.
   */
  itemIndex?: number;
  /**
   * The specification for the column being evaluated.
   */
  column: IItemColumn;
  /**
   * Row data extracted by the item's `itemDetailsRowControl` handler for fast-access within the row.
   */
  rowData: IFaceted;
}

export interface IItemColumnRenderControlOverrides {
  renderer: (props: IItemColumnRendererProps, index?: number, column?: IColumn) => (JSX.Element | null);
}

export const itemColumnRenderControl: ControlFacet<IItemColumnRenderControlProps, IItemColumnRenderControlOverrides> =
  new ControlFacet('itemColumnRender');
